/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DeviceModelDto } from '../models/DeviceModelDto';
import type { EntityModelResponseContainerDeviceModelDto } from '../models/EntityModelResponseContainerDeviceModelDto';
import type { PagedModelEntityModelDeviceModelDto } from '../models/PagedModelEntityModelDeviceModelDto';
import type { PagedResourcesAssemblerDeviceModelDto } from '../models/PagedResourcesAssemblerDeviceModelDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class SystemDeviceModelControllerService {
    /**
     * @returns PagedModelEntityModelDeviceModelDto OK
     * @throws ApiError
     */
    public static list({
        assembler,
        startsWith,
        page,
        size = 100,
        sort,
    }: {
        assembler: PagedResourcesAssemblerDeviceModelDto,
        startsWith?: string,
        /**
         * Zero-based page index (0..N)
         */
        page?: number,
        /**
         * The size of the page to be returned
         */
        size?: number,
        /**
         * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         */
        sort?: Array<string>,
    }): CancelablePromise<PagedModelEntityModelDeviceModelDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/admin/system/compat/models',
            query: {
                'startsWith': startsWith,
                'page': page,
                'size': size,
                'sort': sort,
                'assembler': assembler,
            },
        });
    }
    /**
     * @returns EntityModelResponseContainerDeviceModelDto OK
     * @throws ApiError
     */
    public static create({
        requestBody,
    }: {
        requestBody: DeviceModelDto,
    }): CancelablePromise<EntityModelResponseContainerDeviceModelDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/admin/system/compat/models',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static delete({
        itemId,
    }: {
        itemId: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/admin/system/compat/models/{itemId}',
            path: {
                'itemId': itemId,
            },
        });
    }
    /**
     * @returns EntityModelResponseContainerDeviceModelDto OK
     * @throws ApiError
     */
    public static read({
        itemId,
    }: {
        itemId: string,
    }): CancelablePromise<EntityModelResponseContainerDeviceModelDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/admin/system/compat/models/{itemId}',
            path: {
                'itemId': itemId,
            },
        });
    }
    /**
     * @returns EntityModelResponseContainerDeviceModelDto OK
     * @throws ApiError
     */
    public static update({
        itemId,
        requestBody,
    }: {
        itemId: string,
        requestBody: DeviceModelDto,
    }): CancelablePromise<EntityModelResponseContainerDeviceModelDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/admin/system/compat/models/{itemId}',
            path: {
                'itemId': itemId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns PagedModelEntityModelDeviceModelDto OK
     * @throws ApiError
     */
    public static listWithOtaUpdates({
        sortBy,
        sortDirection,
        assembler,
        startsWith,
        clientVersionId,
        page,
        size = 100,
        sort,
    }: {
        sortBy: string,
        sortDirection: string,
        assembler: PagedResourcesAssemblerDeviceModelDto,
        startsWith?: string,
        clientVersionId?: string,
        /**
         * Zero-based page index (0..N)
         */
        page?: number,
        /**
         * The size of the page to be returned
         */
        size?: number,
        /**
         * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         */
        sort?: Array<string>,
    }): CancelablePromise<PagedModelEntityModelDeviceModelDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/admin/system/compat/modelsWithOTAUpdates',
            query: {
                'startsWith': startsWith,
                'clientVersionId': clientVersionId,
                'sortBy': sortBy,
                'sortDirection': sortDirection,
                'page': page,
                'size': size,
                'sort': sort,
                'assembler': assembler,
            },
        });
    }
    /**
     * @returns PagedModelEntityModelDeviceModelDto OK
     * @throws ApiError
     */
    public static listWithoutOtaUpdates({
        assembler,
        clientVersionId,
        page,
        size = 100,
        sort,
    }: {
        assembler: PagedResourcesAssemblerDeviceModelDto,
        clientVersionId?: string,
        /**
         * Zero-based page index (0..N)
         */
        page?: number,
        /**
         * The size of the page to be returned
         */
        size?: number,
        /**
         * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         */
        sort?: Array<string>,
    }): CancelablePromise<PagedModelEntityModelDeviceModelDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/admin/system/compat/modelsWithoutOTAUpdates',
            query: {
                'clientVersionId': clientVersionId,
                'page': page,
                'size': size,
                'sort': sort,
                'assembler': assembler,
            },
        });
    }
}
